import { SchoolLayout } from "../components/ui/school/SchoolLayout"
import { SettingsTabs } from "../components/ui/school/school-settings/settings-tab"

const SchoolSettingsPage = () => {
  return (
    <SchoolLayout>
      <div className="p-4 md:p-6 lg:p-8 overflow-y-auto">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Settings</h1>
            <p className="text-gray-600 mt-2">Manage your account settings and preferences</p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200">
            <SettingsTabs />
          </div>
        </div>
      </div>
    </SchoolLayout>
  )
}

export default SchoolSettingsPage
